// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20E71","tabsBox":"styles_tabsBox__2SAOR","createButton":"styles_createButton__cdzy6"};